import { render, staticRenderFns } from "./html/events-quiz.html?vue&type=template&id=f66e6270&scoped=true&"
import script from "./learner-type-quiz.vue?vue&type=script&lang=js&"
export * from "./learner-type-quiz.vue?vue&type=script&lang=js&"
import style0 from "./learner-type-quiz.vue?vue&type=style&index=0&id=f66e6270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66e6270",
  null
  
)

export default component.exports